import { ActionService } from 'dashboard-services/services';

import { basicPipelineDashboardActions } from 'actions/modules/datascience/dashboard';

export const statusesActions = (() => {
  const CATEGORIES = {
    PIPELINES: "PIPELINE",
    GROUPS: "ETL",
  }

  const SELECTORS = {
    WARNING: "onlyWarn",
    ERROR: "onlyError",
    RUNNING: "onlyRunning",
    PAUSE: "onlyPaused"
  }

  const CHANGE_VALUE = 'CHANGE_VALUE_STATUSES'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const CLEAR = 'CLEAR_STATUSES'
  const clear = ActionService.makeActionCreator(CLEAR)

  const ADD_TO_HISTORY = 'ADD_TO_HISTORY_STATUSES'
  const addToHistory = ActionService.makeActionCreator(ADD_TO_HISTORY)

  const BACK = 'BACK_STATUSES'
  const back = ActionService.makeActionCreator(BACK)

  const MODES = {
    MAIN: "MAIN",
    DETAILS: "DETAILS",
    HISTORY: "HISTORY",
    SEE_ALL: "SEE_ALL"
  }

  const getNonETLId = (payload, componentStatuses) => payload?.pipelineId || (payload?.dataprepId || componentStatuses?.find(componentStatuses => componentStatuses.component === "dataprep")?.payload?.dataprepId) || payload?.id

  // Formula statuses have no STATUS_TYPE: they come from the Monitor's component status search, under its formula type.
  const FORMULA_TYPE = basicPipelineDashboardActions.MONITORING_TYPE.FORMULA.value
  const isFormulaType = type => type === FORMULA_TYPE

  // A formula status is a run of the pipeline that computed the formula. The formula, as it was in that run, is in the payload.
  const getFormula = status => ({
    groupName: status?.payload?.formulaGroupName,
    name: String(status?.payload?.formulaName || "").replace(/\.json$/, ""),
    version: status?.payload?.formulaVersion
  })

  // Shows a run's details. `formula` is set when the run is shown as that formula's.
  const showDetails = ({ jobId, formula = undefined }) => dispatch => {
    dispatch(addToHistory())
    dispatch(changeValue(MODES.DETAILS, "mode"))
    dispatch(changeValue(jobId, "jobId"))
    dispatch(changeValue(formula, "formula"))
  }

  // Shows the last runs of a group, pipeline or data prep by its name, or of `formula`.
  const showHistory = ({ name, type, formula = undefined }) => dispatch => {
    dispatch(addToHistory())
    dispatch(changeValue(MODES.HISTORY, "mode"))
    dispatch(changeValue(formula ? FORMULA_TYPE : type, "type"))
    dispatch(changeValue(formula ? formula.name : name, "name"))
    dispatch(changeValue(formula, "formula"))
  }

  return {
    ADD_TO_HISTORY,
    CATEGORIES,
    addToHistory,
    back,
    BACK,
    CHANGE_VALUE,
    changeValue,
    clear,
    CLEAR,
    FORMULA_TYPE,
    getFormula,
    getNonETLId,
    isFormulaType,
    MODES,
    SELECTORS,
    showDetails,
    showHistory
  }
})()